<template>
  <div name="max" class="">

    <div class="w-95p mx-auto pb-10 grid md:grid-cols-2 grid-cols-1 space-x-6 ">
      <div class=" w-11/12 mx-auto" >
        <h2 class="text-base font-bold mb-4">Documents</h2>

        <ResourceList  :hasAccess="!shouldShowUpgrade"  :type="typeSelected"></ResourceList>
      </div>

      <div class=" w-11/12 mx-auto" >
        <h2 class="text-base font-bold mb-4">Videos</h2>
        <VideoList   :hasAccess="!shouldShowUpgrade"  :type="typeSelected"></VideoList>
      </div>
      </div>
   
  </div>
</template>

<script>
import { mapGetters } from "vuex";

const ResourceList = () => import("@/components/library/TheResourceList.vue");
const VideoList = () => import("@/components/library/TheVideoList.vue");
import { upgradeMixin } from "@/mixins/upgradeMixin.js";


export default {
  name: "max",
  props: [],
    mixins: [upgradeMixin],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    showForSchool() {
      return this.currentUser.isSchool == true;
    },
    hasDanceAccess() {
      return this.currentAccess.danceAccess
    },
  },
  data() {
    return {
      typeSelected: null,
    };
  },
  created() {
    this.typeSelected = { value: "dance_extra" , name: "dance_extra"  }
  },
  mounted() {},
  methods: {},
  components: {
    ResourceList,
    VideoList
  },
};
</script>

<style scoped>
</style>